import { render, staticRenderFns } from "./ProductAlternative.vue?vue&type=template&id=aa6c163a&"
import script from "./ProductAlternative.vue?vue&type=script&lang=js&"
export * from "./ProductAlternative.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports